import Vue from 'vue'
import {helpers} from "../../helpers";

export default {
    store: {
        namespaced: true,
        store: {
            endpoint: 'reports',
            dispatcher_report: [],
            dispatcher_report_amount: 50,
            transfer_report: [],
            transfer_report_amount: 50,
            forwarding_report: [],
            forwarding_report_amount: 50,
            routelist_report: [],
            routelist_report_amount: 50,
            services_report: [],
            services_report_amount: 50,
            noforwarding_report: [],
            noforwarding_report_amount: 50,
        },
        actions: {
            getDispatcherReport({ state, rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/report/dispatcher', {params: data}).then(r => {
                    if (!r || !r.data) return [];
                    let report = r.data;
                    Vue.set(state, 'dispatcher_report', report);
                    Vue.set(state, 'dispatcher_report_amount', r.total);
                    return report;
                });
            },

            getTransferReport({ state, rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/report/transfer', {params: data}).then(r => {
                    if (!r || !r.data) return [];
                    let report = r.data;
                    Vue.set(state, 'transfer_report', report);
                    Vue.set(state, 'transfer_report_amount', r.total);
                    return report;
                });
            },


            getForwardingReport({ state, rootState }, data) {
                Vue.set(state, 'forwarding_report', []);
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/report/forwarding', {params: data}).then(r => {
                    if (!r || !r.data) return [];
                    let report = Object.assign([], r.data);
                    Vue.set(state, 'forwarding_report', report);
                    Vue.set(state, 'forwarding_report_amount', r.total);
                    return report;
                });
            },

            getServicesReport({ state, rootState }, data) {
                Vue.set(state, 'services_report', []);
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/report/services', {params: data}).then(r => {
                    if (!r || !r.data) return [];
                    let report = Object.assign([], r.data);
                    Vue.set(state, 'services_report', report);
                    Vue.set(state, 'services_report_amount', r.total);
                    return report;
                });
            },

            getRoutelistReport({ state, rootState }, data) {
                Vue.set(state, 'routelist_report', []);
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/report/routelist', {params: data}).then(r => {
                    if (!r || !r.data) return [];
                    let report = Object.assign([], r.data);
                    Vue.set(state, 'routelist_report', report);
                    Vue.set(state, 'routelist_report_amount', r.total);
                    return report;
                });
            },

            getNoForwardingReport({ state, rootState }, data) {
                Vue.set(state, 'noforwarding_report', []);
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/report/noforwarding', {params: data}).then(r => {
                    if (!r || !r.data) return [];
                    let report = Object.assign([], r.data);
                    Vue.set(state, 'noforwarding_report', report);
                    Vue.set(state, 'noforwarding_report_amount', r.total);
                    return report;
                });
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/modules/reports/store.js